import React from 'react';
// import ReactDOM from 'react-dom';
import "../Lib/react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from '../Lib/react-responsive-carousel/lib/es';
import "./testimonial.css";


function App() {
    return <CardCarousel {...CardCarouselData} />;
}

export default App;


function CardCarousel(props) {
    const {
        group273Props,
        group2732Props,
        group2733Props,
        group2734Props,
        group2735Props,
        group2736Props,
    } = props;

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1305 },
    items: 2,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1304, min: 501 },
    items: 2,
    slidesToSlide: 2 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 500, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

        return (
            <Carousel interval={4000} transitionTime={2000} autoPlay={false} infiniteLoop={true} showArrows={false} showStatus={false} showThumbs={false} animationHandler="fade" swipeable={true} responsive={responsive}>
                <div className="test-img">
                    <Group273
                    text278={group273Props.text278}
                    ellipse1={group273Props.ellipse1}
                    name={group273Props.name}
                    text279={group273Props.text279}
                    />
                   
                    <Group273
                    text278={group2732Props.text278}
                    ellipse1={group2732Props.ellipse1}
                    name={group2732Props.name}
                    text279={group2732Props.text279}
                    className={group2732Props.className}
                    /> 
                  
                </div>
                <div className="test-img">
                    <Group273
                    text278={group2733Props.text278}
                    ellipse1={group2733Props.ellipse1}
                    name={group2733Props.name}
                    text279={group2733Props.text279}
                    />
                    
                    
                    <Group273
                    text278={group2734Props.text278}
                    ellipse1={group2734Props.ellipse1}
                    name={group2734Props.name}
                    text279={group2734Props.text279}
                    className={group2734Props.className}
                    /> 
                
                </div>
                <div className="test-img">
                <Group273
                    text278={group2735Props.text278}
                    ellipse1={group2735Props.ellipse1}
                    name={group2735Props.name}
                    text279={group2735Props.text279}
                    />
                     
                     
                    <Group273
                    text278={group2736Props.text278}
                    ellipse1={group2736Props.ellipse1}
                    name={group2736Props.name}
                    text279={group2736Props.text279}
                    className={group2736Props.className}
                    /> 
                  
                   
                    {/* <img className="card-background" src="https://www.halberesford.com/content/images/2018/07/null.png" /> */}
                    {/* <p className="legend">Legend 2</p> */}
                </div>
            </Carousel>
        );
}


function Group273(props) {
    const { text278, ellipse1, name, text279, className } = props;
  
    return (
      <div className={`lpd-group-27 ${className || ""}`}>
        <div className="lpd-overlap-group-1">
          <p className="lpd-text-5-1 lpd-typographybodycaption-14-semi-bold">{text278}</p>
          <div className="lpd-group-120 test-image">
            <img className="lpd-ellipse-1 lpd-ellipse-1-img" src={ellipse1} />
            <div className="lpd-flex-col-1">
              <div className="lpd-name lpd-valign-text-middle lpd-typographyheadlineh3-extrabold-30">{name}</div>
              <div className="lpd-text-5-2 lpd-valign-text-middle lpd-typographybody16-regular">{text279}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const group273Data = {
    text278: "Webuildd handled and executed my end-to-end project including, designing, construction, and interiors; for the construction of my residence. They provide regular updates on the progress and consult for key inputs. They successfully converted the drawing to completely match the built house. They are courteous and pleasant to work with. Satisfied with how they executed the project, I would definitely rehire them for any project in the future.",
    ellipse1: "Images/Home_Page/Img/Testimonial/Generic.png",
    name: "Srinivas",
    text279: "HRBR Layout, Bangalore, India",
};

const group2732Data = {
    text278: "Webuildd has excellent professional knowledge of the entire construction process. They support and helped me throughout; the planning, construction, and finishing.As a first-time homeowner, they were always present to help me with various decisions I had to take. They understood my requirements, changes and have given valuable information and advice. Webuildd is a Single Point of contact for all construction needs.",
    ellipse1: "Images/Home_Page/Img/Testimonial/Generic.png",
    name: "Murali Govindaraju",
    text279: "Srirampura, Bangalore, India",
    className: "lpd-group-27-1",
};

const group2733Data = {
    text278: "At first, I was a little sceptical about assigning the project to Webuildd, considering our budget. But our meeting with the professionals at Webuildd gave us the confidence to go with them. Webuildd's professional expertise was not only cost-effective but also suited our needs and stood out from the other proposals we got. They never compromised on the quality of materials used, however big or small the project is, and didn’t fail to deliver the complete project on time.",
    ellipse1: "Images/Home_Page/Img/Testimonial/Generic.png",
    name: "Vijay",
    text279: "Jalahalli, Bangalore, India",
  };

const group2734Data = {
    text278: "Thanks to a mutual friend, I learned about Webuildd Construction and got introduced to Mr. Ganesh Reddy. My building on the new BEL road has benefited from their attention to detail, which has resulted in a high level of quality. It was done in accordance with their commitment. The Webuildd group will be my first choice if I ever have the chance to build again. For their future endeavours, we wish them well.",
    ellipse1: "Images/Home_Page/Img/Testimonial/Generic.png",
    name: "Yogitha",
    text279: "New Bell Road, Bangalore, India",
    className: "lpd-group-27-1",
};

const group2735Data = {
  text278: "Webuildd takes responsibility and pride in delivering their best service and always accommodate the needs of the client. Spite the challenges posed due to pandemic, they completed the construction of our residence and delivered on time as assured. They excellently executed activities in parallel with good planning and collaboration. Thanks to Webuildd, our Family is satisfied and happy with the overall quality of the beautiful house.",
  ellipse1: "Images/Home_Page/Img/Testimonial/Generic.png",
  name: "Shomith",
  text279: "Kengeri Dodabelle, Bangalore, India",
};
const group2736Data = {
  text278: "Webuildd is one of the best construction firms we've worked with. The entire team is agile, transparent, and has timely delivered a project of exceptional quality with timelines as stated in the contract. It has been a hassle-free experience starting from Borewell, Comprehensive govt approvals to Key Handover.",
  ellipse1: "Images/Home_Page/Img/Testimonial/Generic.png",
  name: "Sunil",
  text279: "Bangalore, India",
  className: "lpd-group-27-1",
};
  

const CardCarouselData  = {
    group273Props: group273Data,
    group2732Props: group2732Data,
    group2733Props: group2733Data,
    group2734Props: group2734Data,
    group2735Props: group2735Data,
    group2736Props: group2736Data,
};